import { Box, BoxProps, Tip } from 'grommet';
import { tooltipProps } from 'src/theme';

export interface ITalonTipProps {
  maxWidth?: string;
  content: JSX.Element;
  children?: JSX.Element;
}

export const TalonTip = ({ content, children }: ITalonTipProps) => {
  return (
    <Tip
      content={
        <Box
          // width={{ max: maxWidth }}
          // background="light-1"
          // round={borderRadiusSize}
          // pad="small"
          // margin="small"
          // border={{ size: '1px', color: 'light-4' }}
          {...(tooltipProps as BoxProps)}
        >
          {content}
        </Box>
      }
      plain={true}
    >
      {children}
    </Tip>
  );
};
